import {Question1Base} from "../base/question1_base_controller";

// Connects to data-controller="questions--designed-in-quebec--question1"
export default class extends Question1Base {
  connect() {
  }
}
